module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Ruefenach_AG-84d59dc6372cd201cba4e3b44481d916.svg";